// extracted by mini-css-extract-plugin
module.exports = {"container":"PyramidAuthors_container__70vWr","mobile":"PyramidAuthors_mobile__xRH7D","releaseDate":"PyramidAuthors_releaseDate__QLJHZ"};